"use client"

import { useSnapshot } from "valtio"
import { AccountState } from "../../stores/accountStore"

export function useChainId() {
  const { chainId } = useSnapshot(AccountState)
  return chainId
}
